import { PostHog as PosthogClientSide } from 'posthog-js'

class PostHogManager {
  private posthogClientSide: PosthogClientSide | null = null
  private initialized = false

  initialize(posthog: PosthogClientSide) {
    this.posthogClientSide = posthog
    this.initialized = true
  }

  isInitialized() {
    return this.initialized && this.posthogClientSide !== null
  }

  getClientInstance() {
    return this.posthogClientSide
  }
}

export const posthogManager = new PostHogManager()
